<template>
  <!-- Vi labels-->
  <span>
    <disambig-view
      label-type="labelType"
      label-caption="labelCaption"
      :fmid="fmid"
      :film="film"
      :count="count"
      hide-title
      @refreshfilm="refreshFilm"
      contentHeading="Films with potential duplicate content"
      disambigTypes="duplicate"

    ></disambig-view>

    <disambig-view
      label-type="labelType"
      label-caption="labelCaption"
      :fmid="fmid"
      :film="film"
      :count="count"
      hide-title
      @refreshfilm="refreshFilm"
      contentHeading="Films with similar content"
      disambigTypes="similar"

    ></disambig-view>

  </span>
</template>
<script>
import Disambigview from "@/components/Disambigview";
export default {
  components: {
    'disambig-view': Disambigview
  },
  methods: {
    refreshFilm (film) {
      this.$emit("refreshfilm", film)
    }
  },
  props: {
    hideTitle: Boolean,
    editable: Boolean,
    film: {
      type: Object,
      required: true
    },
    fmid: {
      type: String
    },
    // identifies the kind of label to be displayed
    labelType: {
      type: String,
      required: true
    },
    labelCaption: {
      type: String,
      required: true
    },
    // this is a summary of counts by type to avoid the query if its not openedup
    count: Number
  }
}
</script>
